export default __webpack_public_path__ + "static/modernHomeForSale-380d95b687f52b66da28fbbfbb6ad50f.svg";